import BookItem from "../common/bookItem";
export default class VisibleSwitchAnsStepChild extends BookItem {
    constructor(el, target) {
        super(el, target);
        this.el = el;
        this.currentOpenAns = false;
        this.connectNumber = this.el.connectNumber;
        this.target.mouseEnabled = false;
        // this.ctrlObjOrder = this.el.ctrlObjOrder;不用了
    }

    init() {
        // super.init();
        this.target.gotoAndStop(0);
        // this.addSingleAntialiasing(this);
    }

    trigger() {
    }
}